import { modalSideSheetContentStyles } from './ModalSideSheetContent.styles';
import { detachedModalSideSheetContentStyles } from './DetachedModalSideSheetContent.styles';
export const sideSheetVariantContentStyles = {
    modal: modalSideSheetContentStyles,
    detachedModal: detachedModalSideSheetContentStyles,
};
